import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import './contactForm.css';

function Contact() {
    const [formData, setFormData] = useState({
        email: '',
        firstName: '',
        lastName: '',
        message: ''
    });

    const [status, setStatus] = useState({
        message: '',
        isError: false
    });

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setStatus({ message: 'Sending...', isError: false });

        try {
            await emailjs.send(
                'service_5xly8zl', // EmailJS service ID
                'template_9n7o0kv', // EmailJS template ID
                {
                    from_email: formData.email,
                    from_name: `${formData.firstName} ${formData.lastName}`,
                    message: formData.message,
                },
                '5bkdTrDja0m2nx2A0' // EmailJS public key
            );

            setStatus({ message: 'Message sent successfully!', isError: false });
            setFormData({ email: '', firstName: '', lastName: '', message: '' });
        } catch (error) {
            setStatus({ message: 'Failed to send message. Please try again.', isError: true });
        }
    };

    return(
        <div className='ContactFormContainer'>
            <form onSubmit={handleSubmit} className='ContactFormFields'>
                <div className='ContactEmailField'>
                    <label>Email</label>
                    <input 
                        type='email' 
                        name='email'
                        value={formData.email}
                        onChange={handleInputChange}
                        placeholder='Your email'
                        required
                    />
                </div>
                <div className='ContactNameFields'>
                    <div className='ContactInputGroup'>
                        <label>First Name</label>
                        <input 
                            type='text'
                            name='firstName'
                            value={formData.firstName}
                            onChange={handleInputChange}
                            placeholder='First name'
                            required
                        />
                    </div>
                    <div className='ContactInputGroup'>
                        <label>Last Name</label>
                        <input 
                            type='text'
                            name='lastName'
                            value={formData.lastName}
                            onChange={handleInputChange}
                            placeholder='Last name'
                            required
                        />
                    </div>
                </div>
                <div className='ContactMessageArea'>
                    <label>Message</label>
                    <textarea 
                        name='message'
                        value={formData.message}
                        onChange={handleInputChange}
                        placeholder='Your message'
                        required
                    />
                </div>
                {status.message && (
                    <div className={`status-message ${status.isError ? 'error' : 'success'}`}>
                        {status.message}
                    </div>
                )}
                <div className='ContactSubmitButton'>
                    <button type='submit'>Submit</button>
                </div>
            </form>
        </div>
    );
}

export default Contact;